import { render, staticRenderFns } from "./Envia.vue?vue&type=template&id=cfaaec3a"
import script from "./Envia.vue?vue&type=script&lang=js"
export * from "./Envia.vue?vue&type=script&lang=js"
import style0 from "./Envia.vue?vue&type=style&index=0&id=cfaaec3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports